import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LinkHrisTeamToOpusRoleMutationVariables = Types.Exact<{
  groupId: Types.Scalars['Int']['input'];
  hrisTeamId: Types.Scalars['Int']['input'];
}>;


export type LinkHrisTeamToOpusRoleMutation = { __typename?: 'Mutation', createHrisTeamLink: { __typename?: 'GenericMutationResult', success: boolean } };


export const LinkHrisTeamToOpusRoleDocument = gql`
    mutation LinkHrisTeamToOpusRole($groupId: Int!, $hrisTeamId: Int!) {
  createHrisTeamLink(groupId: $groupId, hrisTeamId: $hrisTeamId) {
    success
  }
}
    `;
export type LinkHrisTeamToOpusRoleMutationFn = Apollo.MutationFunction<LinkHrisTeamToOpusRoleMutation, LinkHrisTeamToOpusRoleMutationVariables>;

/**
 * __useLinkHrisTeamToOpusRoleMutation__
 *
 * To run a mutation, you first call `useLinkHrisTeamToOpusRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkHrisTeamToOpusRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkHrisTeamToOpusRoleMutation, { data, loading, error }] = useLinkHrisTeamToOpusRoleMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      hrisTeamId: // value for 'hrisTeamId'
 *   },
 * });
 */
export function useLinkHrisTeamToOpusRoleMutation(baseOptions?: Apollo.MutationHookOptions<LinkHrisTeamToOpusRoleMutation, LinkHrisTeamToOpusRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkHrisTeamToOpusRoleMutation, LinkHrisTeamToOpusRoleMutationVariables>(LinkHrisTeamToOpusRoleDocument, options);
      }
export type LinkHrisTeamToOpusRoleMutationHookResult = ReturnType<typeof useLinkHrisTeamToOpusRoleMutation>;
export type LinkHrisTeamToOpusRoleMutationResult = Apollo.MutationResult<LinkHrisTeamToOpusRoleMutation>;
export type LinkHrisTeamToOpusRoleMutationOptions = Apollo.BaseMutationOptions<LinkHrisTeamToOpusRoleMutation, LinkHrisTeamToOpusRoleMutationVariables>;